import { BaseDialog } from '@components/dialog';
import { BtnPrimary } from '@components/buttons';
import { IcoCheck } from '@components/icons';

/**
 * ConfirmedModal - Displayed after the user confirms their email.
 */
export function ConfirmedModal({ hide }: { hide: () => void }) {
  return (
    <BaseDialog onClose={hide} contentWidth>
      <section class="p-10 text-base w-xl flex flex-col gap-6 overflow-auto  leading-normal">
        <header class="flex items-center text-center flex-col gap-4">
          <div class="inline-flex items-center justify-center size-16 rounded-full bg-gradient-to-br from-sky-600 to bg-pink-400 via-violet-400 text-2xl">
            <IcoCheck class="text-white size-12" />
          </div>

          <h1 class="capitalize text-3xl font-bold">Thanks for confirming your email!</h1>

          <p class="text-gray-600 text-lg leading-normal">
            Your page is ready for you to customize and launch.
          </p>
        </header>

        <footer class="flex justify-center">
          <BtnPrimary class="rounded-full py-4 px-8 bg-violet-600" onClick={hide}>
            Let's get started together
          </BtnPrimary>
        </footer>
      </section>
    </BaseDialog>
  );
}
